import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

/**
 * FieldHelpModal - Display help content for financial fields
 * Simple modal showing title and content for any financial field
 */
const FieldHelpModal = ({ isOpen, onClose, helpContent }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
      <div className="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-2xl font-bold text-gray-900">{helpContent.title}</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 min-h-[44px] min-w-[44px] flex items-center justify-center"
            >
              <X size={24} />
            </button>
          </div>

          <div className="prose prose-blue max-w-none">
            <p className="text-gray-700 leading-relaxed">
              {helpContent.content}
            </p>
          </div>

          <button
            onClick={onClose}
            className="mt-6 w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors min-h-[44px]"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

FieldHelpModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  helpContent: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string
  }).isRequired
};

export default FieldHelpModal;
